import {useContext} from 'react'
import {CustomerContext} from '../../CustomerContext'
import Indicators from '@/app/modules/p2c/reports/sponsorship/Indicators'
import SourcesChart from '@/app/modules/p2c/reports/sponsorship/charts/SourcesChart'
import EvolutionChart from '@/app/modules/p2c/reports/sponsorship/charts/EvolutionChart'
import {DateRangeContext} from '@/components/context/DateRangeContext'
import {Card} from '@/components/Card'

const SponsorshipReportPane = () => {
  const { customer } = useContext(CustomerContext)
  const {from, to} = useContext(DateRangeContext)

  if (!customer) {
    return (<></>)
  }

  return (
    <>
      <Indicators from={from} to={to} sponsor={customer._id} />
      <div className="row pt-5">
        <div className="col-xl-4">
          <div className="card mb-5 mb-xl-10">
            <div className="card-body p-9">
              <SourcesChart
                userId={customer._id}
                from={from}
                to={to}
                height={200}
              />
            </div>
          </div>
        </div>

        <div className="col-xl-8">
          <Card title="Evolution">
            <EvolutionChart
              userId={customer._id}
              from={from}
              to={to}
              height={350}
            />
          </Card>
        </div>
      </div>
    </>
  )
}

export default SponsorshipReportPane
